
import { PacingProfile } from '@/types';

export const PACING_PROFILES: PacingProfile[] = [
  {
    id: "funeral-doom",
    label: "Funeral / Doom",
    bpmRange: [30, 55],
    breathingCues: "Cavernous inhales between phrases. Let silence become an instrument. Each breath is a deliberate dramatic pause.",
    phraseLength: "Glacial, elongated phrases. Each word is a monument with crushing weight.",
    syllableDensity: "Extremely sparse. Give each syllable maximum room to decay fully.",
    restBehavior: "Embrace long voids between phrases. Uncomfortable silence is part of the performance.",
    dynamicRange: "Whisper to earthquake. Binary extremes with no middle ground."
  },
  {
    id: "ballad",
    label: "Ballad / Slow Burn",
    bpmRange: [56, 72],
    breathingCues: "Long, deliberate inhales. Let notes decay fully before the next phrase begins.",
    phraseLength: "Extended, drawn-out phrases with emotional weight on each word.",
    syllableDensity: "Sparse. Give each syllable room to breathe and land with impact.",
    restBehavior: "Embrace silence. Let the band fill instrumental space between vocal phrases.",
    dynamicRange: "Intimate verses swelling gradually to powerful, open choruses."
  },
  {
    id: "mid-groove",
    label: "Mid-Tempo Groove",
    bpmRange: [73, 100],
    breathingCues: "Natural conversational breathing. Relaxed but steady, riding the groove.",
    phraseLength: "Medium phrases with room for melodic exploration and dynamic shaping.",
    syllableDensity: "Moderate storytelling pace. Words have weight but maintain natural flow.",
    restBehavior: "Pocket rests. Syncopated pauses that lock with the rhythm section.",
    dynamicRange: "Consistent energy floor with dynamic accent points and subtle builds."
  },
  {
    id: "driving-rock",
    label: "Driving Rock",
    bpmRange: [101, 125],
    breathingCues: "Quick catch breaths. Maintain high energy through phrases without losing steam.",
    phraseLength: "Punchy, direct phrases that hit hard and move forward.",
    syllableDensity: "Dense but articulate. Every word counts and lands on the beat.",
    restBehavior: "Minimal rests. Forward momentum is king. Keep pushing.",
    dynamicRange: "High energy floor with explosive peaks on hooks and key lines."
  },
  {
    id: "high-energy",
    label: "High Energy / Punk",
    bpmRange: [126, 160],
    breathingCues: "Stacked breaths. Machine-gun delivery where needed. Athletic breathing.",
    phraseLength: "Short, percussive bursts. Punk-rock economy of words.",
    syllableDensity: "Rapid-fire. Syllables stacked tight against the beat.",
    restBehavior: "Rests are rare punctuation marks. Exclamation points only.",
    dynamicRange: "Relentless assault with occasional breakdown contrast for impact."
  },
  {
    id: "thrash",
    label: "Thrash / Speed",
    bpmRange: [161, 220],
    breathingCues: "Athletic circular breathing. No gaps. Maximum efficiency.",
    phraseLength: "Machine-gun bursts locked between riff accents.",
    syllableDensity: "Maximum density. Syllables function as percussion.",
    restBehavior: "Rests only for dramatic impact or half-time breakdowns.",
    dynamicRange: "Full throttle with half-time valleys for dynamic contrast."
  }
];

export function getPacingForTempo(bpm: number): PacingProfile {
  const profile = PACING_PROFILES.find(
    p => bpm >= p.bpmRange[0] && bpm <= p.bpmRange[1]
  );
  return profile || PACING_PROFILES[2]; // Default to mid-groove
}
